import React from "react";
import Button from "../../components/Button";
import DatePicker from "../../components/DatePicker";
import SearchInput from "../../components/SearchInput";

const AssetFilterBar = ({
  fromDate,
  search,
  setFromDate,
  setSearch,
  setToDate,
  toDate,
  exporting = false,
  onExportPdf,
  onSearch,
  loading,
  variant = "desktop",
}) => {
  const isMobile = variant === "mobile";

  const handleSubmit = (event) => {
    event.preventDefault();
    onSearch();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={[
        "w-full motion-safe:animate-[fadeIn_240ms_ease-out]",
        isMobile
          ? "rounded-2xl bg-white p-3 shadow-sm"
          : "flex flex-wrap items-center justify-between gap-3",
      ].join(" ")}
    >
      <div
        className={[
          "flex w-full gap-3",
          isMobile ? "flex-col" : "flex-wrap items-center",
        ].join(" ")}
      >
        <SearchInput
          value={search}
          placeholder="Tìm kiếm tài sản"
          buttonType="submit"
          submitOnEnter={false}
          onChange={(event) => setSearch(event.target.value)}
          className={isMobile ? "" : "md:w-[320px] xl:w-[320px]"}
        />

        <div
          className={
            isMobile ? "w-full" : "w-full min-w-[290px] max-w-[290px]"
          }
        >
          <DatePicker
            placeholder="Từ ngày"
            value={fromDate || ""}
            onChange={setFromDate}
            height="42px"
          />
        </div>

        <div
          className={
            isMobile ? "w-full" : "w-full min-w-[290px] max-w-[290px]"
          }
        >
          <DatePicker
            placeholder="Đến ngày"
            value={toDate || ""}
            onChange={setToDate}
            height="42px"
          />
        </div>

        <Button
          type="submit"
          variant="primary"
          size="lg"
          aria-busy={loading}
          disabled={loading}
          className={isMobile ? "w-full" : ""}
        >
          Áp dụng
        </Button>

        {onExportPdf && (
          <div className={isMobile ? "w-full" : "ml-auto"}>
            <Button
              type="button"
              variant="secondary"
              size="lg"
              aria-busy={exporting}
              disabled={exporting || loading}
              isLoading={exporting}
              onClick={onExportPdf}
              className={isMobile ? "w-full" : ""}
              rightIcon={
                <img
                  src="/icons/download.svg"
                  alt=""
                  className="size-4"
                />
              }
            >
              <span>{exporting ? "Đang xuất..." : "Xuất file PDF"}</span>
            </Button>
          </div>
        )}
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </form>
  );
};

export default AssetFilterBar;
